export const primaryLight = "#ECECE7";
export const primaryDark = "#0E0E10";
export const secondaryLight = "#C2C7C4";
export const secondaryDark = "#383E42";
export const tertiary = "#f9eddb";
